<template>
    <div :style="getStyle">
        <button
            class="btn btn-sm btn-confirm action-button-component"
            :style="{'background-color': getBackgroundColor }"
            :disabled="!getActive"
            :class="!getActive ? 'mark-disabled' : ''"
            v-popover:tooltip.top.auto="t(getTitle)"
            @click.prevent="onClick">
            {{ t(getName) }}
        </button>
    </div>
</template>

<script>

export default
{
    components: {},
    props: {
        config: {
            type: Object,
            default: function() {
                return {
                    name: null,
                    backgroundColor: null,
                    title: null,
                    active: true,
                    emitEvents: [],
                    uploadFile: false,
                }
            }
        },
        parentState: {
            type: Object,
        },
    },
    data() {
        return {
            active: true,
            name: null,
            title: null,
            backgroundColor: null,
        };
    },
    computed: {
        getStyle() {
            return this.config.style || {margin: "1px", float: "left"};
        },
        getActive() {
            return this.active;
        },
        getBackgroundColor() {
            return this.backgroundColor;
        },
        getName() {
            return this.name || '';
        },
        getTitle() {
            return (this.title || this.config.title) || '';
        },
    },
    inject: ['eventManager'],
    mounted() {
        this.init();
        this.mountEvents();
    },
    beforeDestroy() {
        this.eventManager.unbindEvents(this.defaultBindEvents());
    },
    methods: {
        init() {
            this.componentIndex = this.config.index;
            this.title = this.config.title;
            this.name = this.config.name;
            this.backgroundColor = this.config.backgroundColor;
            this.active = this.config.active;
            this.internalRow = {};
        },
        defaultBindEvents() {
            return [{
                name: 'showComponent',
                componentIndex: this.componentIndex,
            },{
                name: 'hideComponent',
                componentIndex: this.componentIndex,
            }];
        },
        hideComponent() {
            this.active = false;
        },
        mountEvents() {
            this.eventManager.bindEvents(this.defaultBindEvents(), this);
        },
        onClick() {
            let state = this.parentState;
            this.eventManager.emitEvents(this.config.emitEvents['click'], [{state: state.value}]);
        },
        showComponent() {
            this.active = true;
        },
    },
}
</script>

<style lang="sass" scoped>
    .mark-disabled {
        opacity: 0.4!important;
    }
    .action-button-component:hover {
        opacity: 0.7!important;
    }
</style>



// WEBPACK FOOTER //
// ActionButtonComponent.vue?0a65cd24